module.exports = __webpack_public_path__ + "img/star-fox.2772b793.png";